import type { Connector } from '@avalara/types/index';
import type { PaymentMethod } from 'types/biztech';

import type * as Actions from '@avalara/types/actions';
import type { ReceiveUserOptions } from '@avalara/types/index';

export const receiveUser = (options: ReceiveUserOptions): Actions.ReceiveUser => ({
  ...options,
  type: 'RECEIVE_USER',
});

export const setPartnerConnector = (connector: Connector): Actions.SetPartnerConnectorAction => ({
  type: 'SET_PARTNER_CONNECTOR',
  connector,
});

export const addCreditCard = (paymentMethodToken: string): Actions.AddCreditCard => ({
  type: 'ADD_CREDIT_CARD',
  paymentMethodToken,
});

export const receivePaymentMethods = (paymentMethods: Array<PaymentMethod>): Actions.PaymentMethodsAction => ({
  type: 'RECEIVE_PAYMENT_METHODS',
  paymentMethods,
});

export const setConnector = (connector: Connector): Actions.SetConnector => ({ type: 'SET_CONNECTOR', connector });

export const setSelectedPaymentMethod = (paymentMethodId: string | null): Actions.SetSelectedPaymentMethod => ({
  type: 'SET_SELECTED_PAYMENT_METHOD',
  paymentMethodId,
});

export const setReferrer = (referrer: string | null): Actions.SetReferrer => ({ type: 'SET_REFERRER', referrer });

export const setAccountSetupRetryKey = (retryKey: string): Actions.SetAccountSetupRetryKey => ({
  type: 'SET_ACCOUNT_SETUP_RETRY_KEY',
  retryKey,
});

export const setReturnUrl = (returnUrl: string | null): Actions.SetReturnUrl => ({ type: 'SET_RETURN_URL', returnUrl });
